import {ResolvingLitElement} from "../../lib/ResolvingLitElement.js";
import {html} from "lit";
import {BillingPeriodWidget} from "../components/BillingPeriodWidget.js";
import {PlanningPeriodWidget} from "../components/PlanningPeriodWidget.js";
import {SettingsRepository} from "../../app/SettingsRepository.js";
import {TimesheetEntryRepository} from "../TimesheetEntryRepository.js";
import {TimesheetEntryLiveService} from "../TimesheetEntryLiveService.js";
import ToastifyEs from "toastify-js/src/toastify-es.js";
import {Router} from "@vaadin/router";
import {TimesheetEntryTableWidget} from "../components/TimesheetEntryTableWidget.js";
import {AbstractTimesheetPage} from "../AbstractTimesheetPage.js";
import PlannedTimeService from "../../time-plan/PlannedTimeService.js";
import {DateTime} from "luxon";
import {TimeTool} from "../../lib/TimeTool.js";

export class FinancialPage extends AbstractTimesheetPage {

    static properties = {
        currentMonth: { type: String },
    }

    constructor() {
        super();
        this.currentMonth = DateTime.now().toFormat('yyyy-MM');
    }

    renderPage() {
        return html`
            <div class="container">
                <x-billing-period-widget></x-billing-period-widget>
                <x-planning-period-widget></x-planning-period-widget>
                <x-timesheet-entry-widget></x-timesheet-entry-widget>
            </div>
            
        `;
    }

    whenConnected() {
        this.addEventListener('customer-clicked', evt => {
            this.renderRoot.querySelector('x-timesheet-entry-widget').customerId = evt.detail;
        });
        this._plannedTimeService = new PlannedTimeService(this._plannedTimeRepo, this._plannedTimes);
    }

    get startOfMonth() {
        return DateTime.fromISO(this.currentMonth + '-02').setZone('Europe/Berlin').startOf('month').toJSDate();
    }

    get endOfMonth() {
        return DateTime.fromISO(this.currentMonth + '-02').setZone('Europe/Berlin').endOf('month').toJSDate();
    }

    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.addEventListener('month-changed', evt => {
            this.currentMonth = evt.detail;
        });
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);
        this._updateServiceTimeRange();
    }

    /**
     * @protected
     */
    _updateServiceTimeRange() {
        console.log('Updating to ', this.startOfMonth.toLocaleDateString(), this.endOfMonth.toLocaleDateString(), this.startOfMonth.toLocaleTimeString());
        this._plannedTimeService.setTimeRange(this.startOfMonth, this.endOfMonth);
    }
}

customElements.define('x-financial-page', FinancialPage);